<template>
  <div id="app">
    <AppHeader/>
    <!--<div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/start">Start</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/map">Map</router-link> |
      <router-link to="/route">Route</router-link>
    </div>-->
    <router-view/>
    <AppFooter/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Raleway:300,400,500,700|Roboto+Slab:300,400&display=swap');

:root {
  --color-primary:#80CEC1;
  --color-orange:#F3690B;
  --color-violet:#A34DAF;
  --color-jade:#28B2A8;
  --color-dark-red:#75413E;
  --color-dark-blue:#397C8B;
  --color-black: #313131;
  --color-beige: #F8F6EB;
  --breakpoint-xxs:0;
  --breakpoint-xs:375px;
  --breakpoint-sm:576px;
  --breakpoint-md:768px;
  --breakpoint-lg:992px;
  --breakpoint-xl:1200px;
  --breakpoint-xxl:1600px;
  --breakpoint-xxxl:1950px;
  --font-family-primary:"Raleway", "Roboto Mono",-apple-system,BlinkMacSystemFont,"Helvetica Neue",sans-serif;
  --font-family-accent: "Roboto Slab", serif;
}

.color-primary{
  color: var(--color-primary);
}

.color-dark-blue{
  color: var(--color-dark-blue);
}

*,::after,::before {
  box-sizing: border-box
}

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}

html {
  font-family: var(--font-family-primary);
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

article,aside,figcaption,figure,footer,header,hgroup,main,nav,section {
    display: block
}

a{
  color: var(--color-dark-blue);
  text-decoration: none;
  transition: all ease .3s;

  &:hover, &:focus{
    color: var(--color-primary);
  }
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }

  @media (min-width: 1240px) {
    max-width: 1200px;
  }
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.side-title{
  position: fixed;
  top: 50%;
  left: 15px;
  transform: rotate(-90deg) translateX(-50%);
  transform-origin: top left;
}

.urs{
  font-family: var(--font-family-accent);
}

.form-control{
  display: block;
  outline: none;
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: none;
  border: 1px solid#050711;
  box-shadow: inset -3px -3px 0 0 white, -5px -5px 0 #F8F6EB;
  background:#F8F6EB;
  font-family: inherit;
  font-weight: 600;
  border-radius:0;

  &.text-input{
    width: 100%;
    font-size: 1.3rem;
    padding: 8px 18px;
  }
}

.button-primary{
  box-shadow: inset -3px -3px 0 0 white, -5px -5px 0 0#80CEC1;
  background:#80CEC1;
  cursor: pointer;
  padding:7px;

  img{
    display: block;
    height: 30px;
  }
}

/**
 * specific styles
 */
$headerLogoHeight: 60px;
$headerPadding: 15px;
$footer-height: 120px;

#app{
  margin-top: $headerLogoHeight + 2 * $headerPadding;
}

main{
  min-height: calc(100vh - #{$headerLogoHeight + 2 * $headerPadding} - #{$footer-height});
}
</style>
